// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BoxCard_wrapper__eYHBa","text":"BoxCard_text__I8m17","iconWrapper":"BoxCard_iconWrapper__h3drb","lead":"BoxCard_lead__x2Sym"};